import { BehaviorSubject } from 'rxjs';

import { handleResponse, authHeader } from '../helpers';

const currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser')));

const BASE_URL = process.env.REACT_APP_API_URL;
const LEVEL_ADMIN = 0;
const LEVEL_MANAGE = 5;
const LEVEL_REPORTS = 10;
const LEVEL_STOCK = 20;

export const authenticationService = {
    login,
    logout,

    currentUser: currentUserSubject.asObservable(),
    get currentUserValue () { return currentUserSubject.value }
};

function login(profile, tokenObj) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({
            "token": tokenObj.id_token,
            "imageUrl": profile.imageUrl,
        })
    };
    return fetch(BASE_URL + '/auth', requestOptions)
        .then(handleResponse)
        .then(user => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify(user));
            currentUserSubject.next(user);
            return user;
        })
        .catch(err => console.log(err));
}

function logout() {
    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    }
    localStorage.removeItem('currentUser');
    if (authenticationService.currentUserValue) {
        return fetch(BASE_URL + '/logout', requestOptions)
            .then(handleResponse)
            .then(response => {
                // remove user from local storage to log user out
                currentUserSubject.next(null);
            })
    }
}
